module.exports = __webpack_public_path__ + "img/help.7dc945b8.png";